import { DocumentsPanel } from '@/components/staff/DocumentsPanel';
import { portalApi } from '@/lib/api';

export default function PortalDocuments() {
  return (
    <div className="space-y-4" data-testid="portal-documents">
      <div>
        <h1 className="font-heading text-2xl font-700 text-charcoal">My Documents</h1>
        <p className="text-sm text-muted-ink">Upload and keep your work permit, ID, certificates and hiring paperwork here.</p>
      </div>
      <DocumentsPanel api={portalApi} basePath="/staff/me" canUpload canDelete={false} emptyLabel="You haven't uploaded any documents yet." />
    </div>
  );
}
